module.exports = __webpack_public_path__ + "img/PR1.522ad5b4.gif";